<template>
	<!-- 修改密码 -->
	<div>
		<div class="autonym"> 
            <div class="a_center">
                <span class="leftname">手机号码:</span>
                <input type="text" class="input" disabled v-model="customerDatas.phone">
            </div>
            <div class="a_center">
                <span class="leftname">验证码:</span>
                <input type="text" placeholder="请输入验证码" class="input" maxlength="6" v-model="formDatas.code">
                <button class="send_code2" @click="enterpriseSendCode" :disabled="disabled" :class="{ sendding : disabled }">{{ enterpriseCode }}</button>
            </div>
            <div class="a_center">
                <span class="leftname">设置新密码:</span>
                <input type="password" placeholder="请输入您的新密码" class="input" v-model="formDatas.passwd">
            </div>
            <div class="a_center">
                <span class="leftname">重复新密码:</span>
                <input type="password" placeholder="请再次输入您的新密码" class="input" v-model="formDatas.repasswd">
            </div>
            <button class="zenbu2" @click="repassSub">提交</button>
		</div>
	</div>
</template>

<script>
import qs from 'qs'

export default {
	name: 'Repass',
	inject: ['reload'],
	data (){
		return{
			token: localStorage.getItem('apiToken'),
			customerDatas: [],
			formDatas: 
            {
                passwd: '',
                repasswd: '',
                code:''
            },
			enterpriseCode: '获取验证码',
			disabled: false,
			only_once: true
		}
	},
	created(){
		this.getCustomer();
	},
	methods: {
		// 发送验证码
		enterpriseSendCode () {
			const pattern = /0?(13|14|15|17|18|19)[0-9]{9}/;
			if( this.customerDatas.phone == '' || !pattern.test(this.customerDatas.phone) ){
				this.error = '手机号码格式不正确'
				this.$alert(this.error, '提示', {
					confirmButtonText: '确定'
				});
				this.only_once = true
			} else {
				if( this.only_once == true ){
					this.only_once = false;
					let phoneData = qs.stringify({'phone': this.customerDatas.phone})
					this.axios.post(this.$global.apiUrl.send_code, phoneData, {
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					})
					.then((response) => {
						if (response.data.error.code == 0){
							let times = 0
							let i = setInterval(() => {
								times++
								if (times >= 60) {
									this.disabled = false,
									this.enterpriseCode = "重新获取"
									clearInterval(i)
								} else {
									let balance = 60 - times
									this.enterpriseCode = balance + "s",
									this.disabled = true
								}
							}, 1000)
							this.$alert('发送成功', '提示', {
								confirmButtonText: '确定'
							});
						}else{
							this.error = response.data.error.message
							this.$alert(this.error, '提示', {
								confirmButtonText: '确定'
							});
							this.only_once = true
						}
					})
					.catch(() => {})
				}
			}
		},
		// 提交
		repassSub (){
			var r = confirm("您确定提交");
			if (r == true){
				let realDatas = qs.stringify({
                    apiToken: this.token,
                    passwd: this.formDatas.passwd,
                    repasswd: this.formDatas.repasswd,
                    code:  this.formDatas.code,
				})
				this.axios.post(this.$global.apiUrl.customer_repass, realDatas, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				})
				.then((response) => {
					if (response.data.error.code == 0){
						this.$alert('密码修改成功，请牢记新密码', '提示', {
							confirmButtonText: '确定'
                        });
                        this.formDatas.passwd = '';
                        this.formDatas.repasswd = '';
                        this.formDatas.code = '';
					}else{
						this.$alert(response.data.error.message, '提示', {
							confirmButtonText: '确定'
						});
					}
				})
				.catch(() => {})
			}
		},
		getCustomer: function(){
			// 请求个人资料数据
			this.axios.get(this.$global.apiUrl.customer, {
				params: {
					apiToken: this.token
				}
			})
			.then((response) => {
				if(response.data.error.code == 0){
					this.customerDatas = response.data.customer;
					
				}
			})
			.catch(() => {})
		}
	}
}
</script>
<style scoped>
.auto-tab {
	cursor: pointer;
	padding: 0 10px;
	font-size: 12px;
}
.tab-curr {
	font-size: 16px;
	color:#c71622;
}
.send_code2{
	min-width: 90px;
	padding: 5px 10px;
	border: 0;
	background-color: #c71622;
	color: #fff;
	margin-left: -96px;
	border-radius: 5px;
}
.zenbu2{
	text-align: center;
	width: 300px;
	height: 50px;
	line-height: 50px;
	background-color:	#d6363b;
	color: #ffffff;
	border: none;
	font-size: 24px;
	border-radius: 10px;
	margin-top: 10px;
	margin-bottom: 50px;
	margin-left: 35%;
	position: relative;
	left: -150px;
	top: 0px;
}
@media screen and (max-width: 540px){
    .zenbu2{
		width: 100%;
		margin: 1rem auto;
		left: 0;
	}
}
</style>